import React, { useEffect, useRef, useState } from "react";
import tw, { styled, css } from "twin.macro";
import { BsTelephone } from "react-icons/bs";
import { useStaticQuery, graphql } from "gatsby";
import { stripPhoneNumber } from "../../lib/functions";

const Button = styled.a(({ show }) => [
  tw`z-excessive lg:hidden fixed bottom-0 left-0 flex items-center justify-center p-8 m-4 duration-700 rounded-full opacity-0 translate-y-[calc(100% + 1rem)]`,

  css`
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  `,

  !!show && tw`blur-0 translate-y-0 opacity-100`,
]);

const Ping = tw.div`w-[75%] h-[75%] absolute  bg-primary rounded-full animate-ping z-behind`;
const BG = tw.div`bg-primary rounded-full w-full h-full absolute shadow-xl`;

const CTC = ({ ...rest }) => {
  const { mainNumber } = useStaticQuery(graphql`
    {
      wp {
        esquireAcf {
          firmInformation {
            mainNumber
          }
        }
      }
    }
  `).wp.esquireAcf.firmInformation;

  const first = useRef(true);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (first.current === true)
      setTimeout(() => {
        setShow(true);
        first.current = true;
      }, 2000);
  }, []);

  return (
    <Button {...rest} show={show} href={`tel:${stripPhoneNumber(mainNumber)}`}>
      <Ping />
      <BG />
      <BsTelephone tw="absolute text-3xl text-white" />
    </Button>
  );
};

export default CTC;
